import { FETCH_WORKOUT_BY_ID_FETCHING, FETCH_WORKOUT_BY_ID_FINISHED } from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    workout: {},
    isFetching: false
};

const workoutByIdFetching = (state) => ({
    ...state,
    isFetching: true
});

const workoutByIdFetchFinished = (state, action) => {
    return {
        ...state,
        workout: action.workoutById,
        isFetching: false
    };
};

const handlers = {
    [FETCH_WORKOUT_BY_ID_FETCHING]: workoutByIdFetching,
    [FETCH_WORKOUT_BY_ID_FINISHED]: workoutByIdFetchFinished
};

export const getWorkoutById = (state) => {
    return state.workoutById;
};

export const isWorkoutFetching = (state) => {
    return state.workoutById.isFetching;
};

export default function workoutById(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
